import { data } from '../../svg/Edit/data';
import { makeIcon } from '../makeIcon';

export const Edit = makeIcon(data, 'edit', 'Edit');

export default Edit;
